export default __webpack_public_path__ + "assets/no_image.png";